<template>
  <v-container grid-list-md class="no-padding">
    <v-layout wrap>
      <v-flex xs12>
        <v-card class="user">
          <v-card-title>
            <h2>Seznam uporabnikov</h2>
          </v-card-title>

          <v-card-text>
            <table style="width: 100%;">
              <tr>
                <th>#</th>
                <th>Ime</th>
                <th>Priimek</th>
                <th>Email</th>
                <th>Telefon</th>
                <th></th>
              </tr>
              <tr v-for="(user, index) in users" :key="user.id">
                <td>{{ index + 1 }}</td>
                <td>{{ user.data.first_name }}</td>
                <td>{{ user.data.last_name }}</td>
                <td>{{ user.data.email }}</td>
                <td>{{ user.data.phone }}</td>
                <td><router-link :to="'users/' + user.id">Več</router-link></td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import db from '../components/firebaseInit';

export default {
  name: 'profile',

  data() {
    return {
      users: [],
    };
  },

  created() {
    this.getUsers();
  },

  methods: {
    getUsers() {
      db.collection('users').get().then((users) => {
        users.forEach((user) => {
          this.users.push({
            id: user.id,
            data: user.data(),
          });
        });
      });
    },
  },
};
</script>

<style lang="scss">
</style>
